// ============================================================
// ParkEditModal.js — Modale d'édition d'un parc existant
// Enveloppe simplement le formulaire EditForm dans une modale
// Bootstrap. Toute la logique de modification est dans editform.js.
// Props :
//   show      — booléen contrôlant l'affichage de la modale
//   onHide    — ferme la modale
//   client    — objet parc à modifier (pré-remplit le formulaire)
//   authtoken — token Bearer Auth0 pour les requêtes API
// ============================================================

import React from 'react';
import { Modal } from 'react-bootstrap';
import EditForm from './editform.js';

const ParkEditModal = ({ show, onHide, client, experts, authtoken, onRefresh }) => (
  <Modal show={show} onHide={onHide}>
    {/* En-tête : affiche le nom du parc en cours de modification */}
    <Modal.Header closeButton>
      <Modal.Title>{client && client.name}</Modal.Title>
    </Modal.Header>

    {/* Corps : formulaire de modification pré-rempli avec les données du parc */}
    <Modal.Body>
      <EditForm client={client} experts={experts} authtoken={authtoken} onRefresh={onRefresh} onHide={onHide} />
    </Modal.Body>
  </Modal>
);

export default ParkEditModal;
